import { render, staticRenderFns } from "./ReportsDeliveryCanceledView.vue?vue&type=template&id=6749c66c"
import script from "./ReportsDeliveryCanceledView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryCanceledView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports